export default __webpack_public_path__ + "static/media/greyexcel_icon.6b321218.svg";